<template>
  <article v-if="item" class="post-item" :class="['color-'+color, 'type-' + item.post_type, isVisible ? 'hidden' : '', item.family_event ? 'post-item--family-event' : '', item.fringe_event ? 'post-item--fringe-event' : '', item.workshop_event ? 'post-item--workshop-event' : '']">
    <figure class="image" v-if="img">
      <router-link :to="link">
        <img :src="img">
      </router-link>
    </figure>
    <div class="col">
      <router-link :to="link">
        <time v-if="date_str">
          ◔
          {{date_str}}
        </time>
        <p v-if="item.event_stage && item.event_stage !== ''" class="stage">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.42 21.34">
            <path d="M21.42 10.68c0 1.15-1.09 1.87-2.48 2.88L8.37 21.33v-2.91l6.08-4.46c4.06-2.97 5.1-2.07-.17-2.07H0V9.44h14.28c5.27 0 4.23.89.17-2.07L8.38 2.91V0l10.57 7.77c1.38 1.01 2.48 1.76 2.48 2.91Z" fill="currentColor" />
          </svg>
          {{ item.event_stage }}
        </p>
        <p v-if="item.family_event" class="family-event">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.6 21.36">
            <path d="M6.06 0c2.35 0 4.42 1.12 5.74 3.39C13.12 1.12 15.19 0 17.54 0c3.16 0 6.06 2.24 6.06 6.37 0 6.8-6.89 12.52-10.71 14.99h-2.18C6.89 18.89 0 13.18 0 6.37 0 2.24 2.9 0 6.06 0Zm5.74 19c5.86-3.96 9.36-8.41 9.36-12.63 0-2.3-1.38-3.9-3.62-3.9-2.1 0-3.39 1.15-4.65 3.53h-2.18C9.45 3.62 8.16 2.47 6.06 2.47c-2.24 0-3.62 1.61-3.62 3.9 0 4.13 3.42 8.55 9.36 12.63Z" fill="currentColor" />
          </svg>
          Family event
        </p>
        <p v-if="item.workshop_event" class="workshop-event">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.43 23.43">
            <path d="m23.43 23.43-8.45-2.18L1.3 7.57C-.43 5.84-.43 3.02 1.3 1.3a4.436 4.436 0 0 1 6.27 0l13.68 13.68 2.18 8.45Zm-6.45-4.09 2.58.67.44-.44-.67-2.58-2.36 2.36Zm-12.55-17c-.54 0-1.07.2-1.48.61-.81.81-.81 2.14 0 2.95l12.08 12.08 2.95-2.95L5.91 2.95c-.41-.41-.94-.61-1.48-.61Z" fill="currentColor" />
          </svg>
          Workshop
        </p>
        <p v-if="item.vof_event === true || (typeof item.vof_event === 'object' && item.vof_event.is_vof_event)" class="vof-event">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.6 12.92">
            <path fill="currentColor" d="M11.8 12.92C6 12.92 1.47 8.12.62 7.16L0 6.46l.62-.7C1.47 4.8 6 0 11.8 0s9.99 4.41 11.18 5.76l.62.7-.62.7c-.85.96-5.39 5.76-11.18 5.76ZM2.86 6.46c1.48 1.47 4.89 4.35 8.94 4.35s7.46-2.88 8.94-4.35c-1.48-1.47-4.9-4.35-8.94-4.35S4.34 4.99 2.86 6.46Z"/>
            <path fill="currentColor" d="M11.8 10.67a4.21 4.21 0 1 0 0-8.42 4.21 4.21 0 0 0 0 8.42"/>
          </svg>
          {{ typeof item.vof_event === 'object' ? item.vof_event.vof_event_type.label :  "Visions of tomorrow"}}
        </p>
        <p v-if="item.festival_original_event" class="festival-original-event">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.89 22.7">
            <path d="m0 9.46.64-2.01h7.84L10.89 0h2.08l2.44 7.44h7.84l.64 2.01-6.32 4.58 2.41 7.45-1.65 1.22-6.38-4.61L5.6 22.7l-1.71-1.19 2.41-7.48L0 9.46ZM11.93 4.7l-1.68 5.19H4.76l4.42 3.2-1.68 5.22 4.45-3.24 4.43 3.2-1.68-5.19 4.42-3.2h-5.49l-1.71-5.19Z" fill="currentColor" />
          </svg>
          Festival original
        </p>
        <p v-if="item.sold_out" class="sold-out">
          <span>
            Waiting List
          </span>
        </p>
        <p class="post-event-speakers" v-if="item.event_speakers">{{ item.event_speakers }}</p>
        <h2 class="post-title" :class="[item.event_speakers ? '' : 'post-title--top-auto']" v-html="title"></h2>
        <p class="number" v-if="item.part_number" v-html="item.part_number"></p>
        <div class="enter" v-html="excerpt"></div>
        <div class="more" v-if="item.post_type === 'stories'"><span>More</span></div>
      </router-link>
      <ul class="tags" v-if="tags.length !== 0">
        <li v-for="(tag, index) in tags" :key="index">
          <Button :size="'small'" :class="tag.class">{{tag.name}}</Button>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
import Link from '@/components/ui/Link.vue';
import Button from '@/components/ui/Button.vue';
import FormatDate from '@/utils/FormatDate';

export default {
  name: 'post-item',
  components: {
      Link,
      Button,
  },

  props: {
      item: {
        type: Object,
        default: false,
      },
      color: {
        type: String,
        default: 'white',
      },
      isVisible: {
        type: Boolean,
        default: false,
      }
  },

  data() {
    return {
      img: '',
      date_str: '',
      title: '',
      excerpt: '',
      link: '',
      tags: [],
    }
  },

  mounted() {
    if (this.item.related_festival) this.tags.push({
      name: 'Festival',
      link: '',
    });


    switch (this.item.post_type) {
      case 'exhibition':
        this.tags.push({
          name: 'Exhibition',
          link: '/exhibitions',
        });
        break;
      // case 'event':
      //     this.tags.push({
      //         name: 'Event',
      //         link: '/events',
      //     });
      //     break;
      case 'festival':
        this.tags.push({
          name: 'Festival',
          link: '/festivals',
        });
        break;
      case 'podcasts':
        this.tags.push({
          name: 'Podcast',
          link: '/podcasts',
        });
        break;
      case 'people':
        this.tags.push({
          name: 'People',
          link: '/all-people',
        });
        break;
      case 'page':
        this.tags.push({
          name: 'Other',
          link: '/',
        });
        break;
    }


    if (this.item.sold_out) this.tags.push({
      name: 'Fully booked',
      class: 'sold-out',
      link: '/',
    });

    if (this.item.access && this.item.access.length !== 0) {
      this.item.access.forEach(item => {
        this.tags.push({
          name: item.name,
          class:'',
          link: '/type/' + item.slug,
        });
      });
    }

    if (this.item.types && this.item.types.length !== 0) {
      this.item.types.forEach(item => {
        this.tags.push({
          name: item.name,
          class:'',
          link: '/type/' + item.slug,
        });
      });
    }

    this.title = this.item.post_title;
    this.excerpt = this.item.post_excerpt;
    this.link = this.item.link.replace(window.globals.home_url, '');
    this.img = this.item.featured_image.medium_4x3;
    this.date_str = FormatDate(this.item);
  },
}
</script>

<style lang="scss" scoped>
  .post-item {
    position: relative;
    background: white;
    display: flex;
    flex-direction: column;
    width: 100%;
    // min-height: 20rem;
    z-index: 1;
    font-size: 16px;

    &.hidden {
      display: none;
    }

    &.post-item--family-event .col {
      // background-color: var(--theme-1-color-6);
      background-color: #00c8dc;
    }

    &.post-item--workshop-event .col {
      // background-color: var(--theme-1-color-5);
      background-color: #78465a;
    }

    &.post-item--fringe-event .col {
      background-color: #ff2300;
    }

    .image {
      width: 100%;
      position: relative;
      box-sizing: border-box;

      &::before {
        content: '';
        padding: 0 0 100%;
        display: block;
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        object-fit: cover;
      }
    }

    .col {
      flex: 1;
      min-height: calc(170px - 18px);
      padding: 9px;
      box-sizing: border-box;

      a {
        display: flex;
        flex-direction: column;
        min-height: 100%;
      }


      // BELOW TO BE REMOVED
      // a::before {
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   height: 100%;
      //   width: 100%;
      //   z-index: 9;
      //   content: '';
      // }
    }

    @media only screen and (min-width: 768px) {
      .col {
        padding: 16px;
      }
    }

    .sold-out {
      margin-top: 2px;
    }

    .sold-out span {
      padding: 2px;
      background-color: white;
      text-transform: uppercase;
      color: black;
      font-size: clamp(0.75em, 0.457vw + 0.643em, 1em);
    }

    time,
    .stage,
    .family-event,
    .workshop-event,
    .vof-event,
    .festival-original-event {
      display: flex;
      gap: 5px;
      align-items: center;
      text-transform: uppercase;
      font-size: clamp(0.75em, 0.457vw + 0.643em, 1em);
    }

    .stage svg,
    .family-event svg,
    .workshop-event svg,
    .vof-event svg,
    .festival-original-event svg {
      width: min(1em, 14px);
    }



    .post-title,
    .enter {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .post-title {
      text-align: left;
      margin-bottom: 16px;
      padding: var(--padding) 0 0;
      // font-size: clamp(1.45em, 1.829vw + 0.821em, 2.25em);
      line-height: 1.1;
      font-size: clamp(1.219em, 1.719vw + 0.875em, 2.25em);
      // line-height: clamp(1.584em, 1.484vw + 1.288em, 2.475em);
      order: 0;
    }

    .post-title.post-title--top-auto {
      margin-top: auto;
    }

    .post-event-speakers {
      margin-top: 40px;
      order: 0;
      font-size: clamp(0.75em, 0.417vw + 0.667em, 1em);
    }

    .enter {
      display: block;
      font-size: 16px;
      order: 2;
    }

    .tags {
      display: none!important;
      visibility: hidden;
      padding: var(--padding) 0 0;
      display: flex;
      flex-wrap: wrap;

      li {
        padding: 0 var(--padding-50) var(--padding-50) 0;
      }

      span.ui-button {
        min-width: unset;
        margin-bottom: 0;
        &:hover {
          color: black;
          background-color: white;
          border-color: black;
          cursor: default;
        }
      }

      span.sold-out {
        color: white;
        background: black;
        border-color: black;
        &:hover {
          color: white;
          background-color: black;
        }
      }
    }

    &.color-black {
      background: black;

      a {
        color: white;
      }

      .tags {
        span.ui-button {
          background-color: black;
          color: white;
          border-color: white;

          &:hover {
            background: black;
            color: white;
            border-color: white;
            cursor: default;
          }

          &.sold-out {
            color: black;
            background: white;
            border-color: white;
          }
        }
      }
    }

    &.type-stories {
      a:hover {
        color: unset;
      }

      .number {
        color: var(--gray);
        font-size: var(--medium-size);
        margin-top: -.8em;
      }

      // .more {
      //   display: none;
      // }
    }

    &:hover {
      .tags {
        opacity: .5;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .post-item {

      .image {
        width: 100%;
        position: relative;
        box-sizing: border-box;

        &::before {
          padding: 0 0 75%;
        }
      }

      &.type-stories {
        .col {
          padding-top: var(--padding);
          padding-bottom: var(--padding);
        }
      }

      .post-event-speakers {
        padding-top: 24px;
        margin-top: auto;
      }

      .post-title {
        order: 1;
        margin-top: 12px;
        margin-bottom: 0;
        padding: 0;
      }

      .post-title, .enter {
        -webkit-line-clamp: 9;
      }

      .enter {
        display: none;
      }

      .tags {
        li {
          padding-right: var(--padding-50);
        }
      }
    }

  }
</style>
